( function( $ ) {
	$( document ).ready( function () {

		/**
		 * Form submitted event.
		 */
		$( '.fc-form' ).on( 'submit', function( e ) {
			const id = $( this ).data( 'id' );
			if ( 'fc_form_' + id + '_events' in window &&
				window[ 'fc_form_' + id + '_events' ] &&
				'submit_event' in window[ 'fc_form_' + id + '_events' ] ) {

				if ( typeof dataLayer === 'undefined' ) {
					dataLayer = [];
				}

				dataLayer.push({ 'event': window[ 'fc_form_' + id + '_events' ].submit_event });
			}
		} );

		/**
		 * Modal event.
		 */
		$( '[data-toggle="fc_modal"][data-form-id]' ).on( 'click', function( e ) {
			const id = $( this ).data( 'form-id' );
			if ( 'fc_form_' + id + '_events' in window &&
				window[ 'fc_form_' + id + '_events' ] &&
				'modal_event' in window[ 'fc_form_' + id + '_events' ] ) {

				if ( typeof dataLayer === 'undefined' ) {
					dataLayer = [];
				}

				dataLayer.push({ 'event': window[ 'fc_form_' + id + '_events' ].modal_event });
			}
		} );

		/**
		 * On load.
		 */
		$( '[data-toggle="fc_modal"][data-form-id]' ).each( function() {
			const id = $( this ).data( 'form-id' );
			if ( 'fc_form_' + id + '_events' in window &&
				window[ 'fc_form_' + id + '_events' ] &&
				'load_event' in window[ 'fc_form_' + id + '_events' ] ) {

				if ( typeof dataLayer === 'undefined' ) {
					dataLayer = [];
				}

				dataLayer.push({ 'event': window[ 'fc_form_' + id + '_events' ].load_event });
			}
		} );

	} );
} )( jQuery );
